import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Patterns } from 'src/app/helpers/patterns';
import { Requiredaction, UserRest } from 'src/app/models/auth/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { openPrintWindow } from 'src/app/helpers/print.helper';
import Swal from 'sweetalert2';

export interface DialogData {
  action: Requiredaction,
  restaurantId: number
}

@Component({
  selector: 'app-attendence',
  templateUrl: './attendence.component.html'
})
export class AttendenceComponent implements OnInit {
  restaurants: UserRest[] = [];
  formGroup!: FormGroup;
  requiredaction = Requiredaction;

  selectedRest!: UserRest | undefined;
  currentUser = this.authenticationService.currentUserValue;
  isTillRequired = false;
  canContinue = false;

  loading = false;
  printLoading = false

  constructor(
    private dialogRef: MatDialogRef<AttendenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.restaurants = this.currentUser?.owneRestaurant || [];

    // this.restaurants = [this.restaurants[0]];
    // this.restaurants[0].addtill = true;
    // this.restaurants[0].attendancefeature = true;
    // this.restaurants[2].requiredaction = Requiredaction.NoAction;

    this.selectedRest = this.restaurants[0];
    if (this.data.restaurantId) {
      this.selectedRest = this.restaurants.find(r => r.id == this.data.restaurantId);
    }

    this.formGroup = this.formBuilder.group({
      restaurant: [this.selectedRest, [Validators.required]],
      amount: [null, [
        Validators.pattern(Patterns.price2decimal),
      ]],
    });
    this.restaurantChanged();
  }

  restaurantChanged() {
    this.selectedRest = this.formGroup.controls['restaurant'].value;
    if (!this.selectedRest) return;
    localStorage.setItem('restaurantId', String(this.selectedRest.id));
    this.formGroup.controls['amount'].setValue(null);

    // continue
    this.canContinue = false;
    if (
      !this.selectedRest.attendancefeature
      ||
      ( // Allready clock-in
        this.selectedRest.requiredaction != Requiredaction.ClockIn
        && this.data.action == Requiredaction.ClockIn
      )
    ) {
      this.canContinue = true;
    }

    this.isTillRequired = (this.selectedRest.addtill && this.selectedRest.attendancefeature && !this.canContinue);
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  submitClock() {
    this.SetUserAttandance();
  }

  SetUserAttandance(saveAnyway = false) {
    if (this.canContinue) {
      this.dialogRef.close(true);
      return;
    }
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        restaurantId: this.formGroup.controls['restaurant'].value.id,
        amount: this.formGroup.controls['amount'].value,
        status: this.data.action,
        saveAnyway
      };
      this.authenticationService.SetUserAttandance(data).subscribe((resp: any) => {
        if (resp.success) {
          this.loading = false;
          if (resp.code == -6) {
            this.confirmForceClockout();
          }
          else if (resp.code == -3) { // Attendence feature deavtivated after open attendence popup
            this.dialogRef.close();
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: resp.errorMessages,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          } else {
            this.dialogRef.close(true);
            if (this.data.action == Requiredaction.ClockOut) { // ClockOut
              if (this.isTillRequired && !localStorage.getItem('deviceId')) {
                setTimeout(() => { this.print(resp.htmlContent); }, 1000);
              }
              this.authenticationService.logout();
            }
          }
        } else {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: resp.errorMessages,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
          this.dialogRef.close();
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error?.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
        this.dialogRef.close();
        this.authenticationService.logout();
      })
    }
  }

  confirmForceClockout() {
    Swal.fire({
      // title: this.translate.instant('swalMsg.'),
      text: this.translate.instant('auth.Attention Clock-out'),
      icon: 'warning',
      showCancelButton: true,
      title: this.translate.instant('auth.Confirm Clock-Out'),
      confirmButtonText: this.translate.instant('auth.Clock-out anyway'),
      cancelButtonText: this.translate.instant('forms.Cancel')
    }).then((result) => {
      if (result.value) {
        this.SetUserAttandance(true);
      }
    });
  }

  printLastTill() {
    if (!this.selectedRest) return;
    let data: any = {
      restaurantId: this.selectedRest.id
    };
    if (localStorage.getItem('deviceId')) {
      data.deviceId = localStorage.getItem('deviceId');
    }
    this.printLoading = true;
    this.authenticationService.PrintLastTill(data).subscribe((resp: any) => {
      this.printLoading = false;
      if (!localStorage.getItem('deviceId')) {
        setTimeout(() => { this.print(resp.htmlContent); }, 1000);
      }
    }, error => {
      this.printLoading = false;
    })
  }

  print(html: string): void {
    const mywindow: any = openPrintWindow('height=600,width=700');
    if (!mywindow) {
      return;
    }
    mywindow.document.write(html);

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
